import { css, keyframes } from '@emotion/react';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const root = ([size, borderWidth]: string[]) => css`
  width: ${size};
  height: ${size};
  border-radius: 50%;
  position: relative;
  border-top: ${borderWidth} solid var(--color-primary-default);
  border-right: ${borderWidth} solid var(--color-primary-default);
  border-bottom: ${borderWidth} solid var(--color-primary-default);
  border-left: ${borderWidth} solid transparent;
  transform: translateZ(0);
  animation: ${rotate} 0.75s infinite linear;
  &::after {
    width: inherit;
    height: inherit;
    border-radius: 50%;
  }
`;
